"use client"
import Box from "@mui/material/Box"
import { NextImage } from "@src/components"

const Banner = ({ sx = {}, name, imgSrc }) => {

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <NextImage
        src={imgSrc || "/assets/images/no-image.png"}
        alt={name || "Banner"}
        loading="lazy"
        sx={{
          "& .next-image-full": {
            position: "relative !important",
            objectFit: "cover",
            height: "auto !important",
            borderRadius: "16px",
          }
        }}
      />
    </Box>
  )
}

export default Banner
